export default function getPrevMerchantState() {
    return {
        data: {
            merchant: []
        }
    };
}



// WEBPACK FOOTER //
// ./src/Merchants/Reducer/getPrevMerchantState.js